export const PLAYLIST_PATH = {
  public: '/afspeellijst',
  userPlaylist: '/reaguurder/afspeellijst',
  userPlaylists: '/reaguurder/afspeellijsten',
};
